import wacInput from './saveInputs/wacInput';

export default (wac) => `
    deleteWAC (wac: {
        ${wacInput(wac)}
    })
`;
